<template>
    <div class="modal fade" id="updateUserHelpModal" role="dialog" aria-labelledby="updateUserHelpModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="updateUserHelpModalLabel">{{$t('help.title')}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <UserHelpEditCard v-model="model"
                                      v-if="showEditor"
                                      @save="onEdit"
                                      @cancel="onCancel">
                    </UserHelpEditCard>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { UserHelp } from "@/models/models";
import UserHelpEditCard from "./UserHelpEditCard";

export default {
    components: {
        UserHelpEditCard,
    },
    props: {
        value: {
            type: Object,
            required: false,
        },
        show: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            showEditor: false,
            model: new UserHelp(),
        };
    },
    methods: {
        onClose() {
            this.$emit("onClose", { ...this.model });
            this.model = new UserHelp();
            this.$validator.reset();
        },
        hide() {
            $(this.$el).modal("hide");
        },
        onEdit(model) {
            this.$emit("onEdit", model);
            this.onClose();
        },
        onCancel() {
            this.onClose();
        },
    },
    mounted() {
        // add modal close listener
        $(this.$el).on("hidden.bs.modal", this.onClose);
    },
    beforeDestroy() {
        // remove listener
        $(this.$el).off("hidden.bs.modal");
    },
    watch: {
        show: function (val) {
            if (val) {
                this.model = new UserHelp(this.value);
                this.showEditor = true;
                $(this.$el).modal("show");
            } else {
                $(this.$el).modal("hide");
            }
        },
    },
};
</script>

